import { RequestOptions } from './../../services/base.service';
import { OrderLine } from './../../models/ordering/order-line.model';
import { StatusMessageIdResultDto, StatusMessageResultDto } from './../general/project.service';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { FilterOutput, FilterInput } from 'src/app/models/filter-objects';
import { MRPAutoCompleteLst, ReplnOverviewModel } from 'src/app/models/forecast/repln-overivew-model';
import { MRPOverviewPram, OrderOverviewPram } from 'src/app/models/mrp/mrp-overview-moels';
import { Order } from 'src/app/models/ordering/order.model';
import { BaseService } from 'src/app/services/base.service';
import { ListElement } from './deepdive/deepdive.component';

@Injectable({
	providedIn: 'root'
})
export class MRPService {

	private static readonly REQUEST_TOP_PATH: string = "MRP";

	private _baseService: BaseService = inject(BaseService);

	public getReplenishmentVendorList(requestOptions?: RequestOptions): Observable<ReplnOverviewModel> {
		const requestEndpoint: string = "GetReplnVendorList";

		let url = `${MRPService.REQUEST_TOP_PATH}/${requestEndpoint}`;

		return this._baseService.get(
			url,
			requestOptions
		);
	}

	GetReplnOverviewData(vendorlist, numofdays: string) {
		let url = `MRP/GetRplndata?numofdays=${numofdays}`;
		return this._baseService.post<ReplnOverviewModel>(url, vendorlist);
	}

	/* get forecast overview filter data */
	GetMrpFiltersNew(SettingGroupId: number = 0, filterOutout: FilterOutput[]): Observable<FilterInput[]> {
		let url = `MRP/GetMRPFiltersNew?filters.settingGroupId=${SettingGroupId}`;
		let filterData = {
			SettingGroupId: SettingGroupId,
			Action: "", filtersOptions: filterOutout, Unit: "", UnitOfMeasure: ""
		};
		return this._baseService.post(url, filterData);
	}

	/* get forecast overview filter data */
	SelectMrpOverviewData(filterOutout: MRPOverviewPram,requestOptions?: RequestOptions): Observable<Object> {
		let url = `MRP/GetOverviewTable`;
		return this._baseService.post(url, JSON.stringify(filterOutout),requestOptions);
	}

	GetMrpDeepDive(EsoObjectID: string): Observable<Object> {
		let url = `MRP/GetDeepDiveData?id=` + encodeURIComponent(EsoObjectID);
		return this._baseService.post(url);
	}

	GetMrpDeepDiveAutoComplete(): Observable<MRPAutoCompleteLst> {
		let url = `MRP/GetDeepDiveAutoComplete`;
		return this._baseService.post(url);
	}

	GetMrpDeepDiveTable(action: string) {
		let url = `MRP/SelectMrpDeepDiveTable?action=` + encodeURIComponent(action);
		return this._baseService.post(url);
	}

	getMrpActionsList(): Observable<ListElement[]> {
		let url = 'MRP/GetMrpActionsList';
		return this._baseService.get(url);
	}

	saveMrpActionChanges(newAction: string, newComment: string, productId: string): Observable<boolean> {
		let url = `MRP/SaveMrpActionChanges?newAction=${newAction}&newComment=${newComment}&productId=${encodeURIComponent(productId)}`;
		return this._baseService.post(url);
	}

	private readonly _insertOrderLinesRequestEndpoint: string = "InsertOrderLines";

	public insertOrderLines(
		orderLines: OrderLine[],
		requestOptions?: RequestOptions
	): Observable<StatusMessageResultDto> {
		let url = `MRP/${this._insertOrderLinesRequestEndpoint}`;

		return this._baseService.post(url, orderLines, requestOptions);
	}

	private readonly _updateOrderLinesRequestEndpoint: string = "UpdateOrderLines";

	public updateOrderLines(
		orderLines: OrderLine[],
		requestOptions?: RequestOptions
	): Observable<StatusMessageResultDto> {
		let url = `MRP/${this._updateOrderLinesRequestEndpoint}`;

		return this._baseService.post(url, orderLines, requestOptions);
	}

	private readonly _insertOrderRequestEndpoint: string = "InsertOrder";

	public insertOrder(
		order: Order,
		requestOptions?: RequestOptions
	): Observable<StatusMessageIdResultDto> {
		let url = `MRP/${this._insertOrderRequestEndpoint}`;

		return this._baseService.post(url, order, requestOptions);
	}

	private readonly _updateOrderRequestEndpoint: string = "UpdateOrder";

	public updateOrder(
		order: Order,
		requestOptions?: RequestOptions
	): Observable<StatusMessageIdResultDto> {
		let url = `MRP/${this._updateOrderRequestEndpoint}`;

		return this._baseService.post(url, order, requestOptions);
	}

	/* Get Order Optimizer OverView filter data */
	GetOrderOptimizerOverViewFilter(filterOutout: FilterOutput[]): Observable<FilterInput[]> {
		let url = `MRP/GetOrderOptimizerOverViewFilter?filters.settingGroupId=${0}`;
		let filterData = {
			SettingGroupId: 0,
			Action: "", filtersOptions: filterOutout, Unit: "", UnitOfMeasure: ""
		};
		return this._baseService.post(url, filterData);
	}

	/* Get Order Optimizer OverView filter data */
	GetOrderOptimizerOverView(filterOutout: OrderOverviewPram): Observable<Object> {
		let url = `MRP/GetOrderOptimizerOverView`;
		return this._baseService.post(url, JSON.stringify(filterOutout));
	}

	/* Get Order Optimizer OverView filter data */
	SaveMrpOrderData(saveData: any): Observable<Object> {
		let url = `MRP/SaveMrpOrderData`;
		return this._baseService.post(url, JSON.stringify(saveData));
	}

	/* Get Order Optimizer OverView filter data */
	SelectListForDropDown(): Observable<DropDownValues[]> {
		let url = `MRP/SelectListForDropDown`;
		return this._baseService.post(url);
	}

	/* running exit code */
	StartProcess(): Observable<DropDownValues[]> {
		let url = `MRP/StartProcess`;
		return this._baseService.post(url);
	}

	/* check running process */
	CheckRunningProcess(): Observable<DropDownValues[]> {
		let url = `MRP/CheckProcess`;
		return this._baseService.post(url);
	}

	/* Order Optimizer Settings */
	OrderOptimizerSettings(): Observable<any> {
		let url = `MRP/OrderOptimizerSettings`;
		return this._baseService.post(url);
	}
}


export class DropDownValues {
	Value: string;
	Text: string;
	Type: string;
	OrderBy: string;
}
